import ContainerValidation from './Components/ContainerValidation';
import HeaderValidation from './Components/HeaderValidation';
import BodyValidation from './Components/BodyValidation';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import routes from '../../../../Routes/routes';
import { IconIdentityApproved } from '../../../../components/buttons/IconButtons';
import {getUrlParameters} from "./Model/Model";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const SuccessfullyVerified = () => {
    const { id, guardFlowId } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <ContainerValidation>
            <HeaderValidation url={getUrlParameters({url: routes.invitationDetails.registrationProcess, id, guardFlowId})} />

            <BodyValidation
                showBtnNext={false}
                showBtnPrev={true}
                clickPrev={() => {
                    navigate(getUrlParameters({url:routes.invitationDetails.registrationProcess, id, guardFlowId}))
                }}
            >
                <>
                    <div className="row">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("your_identity_has_been_successfully_verified")}</p>
                            <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("upon_arrival_at_the_company_no_additional_steps_are_required")}</p>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center align-items-center">
                        <div className="icon-identity-validation-container">
                            <IconIdentityApproved className="w-100 h-100" />
                        </div>
                    </div>
                </>
            </BodyValidation>
        </ContainerValidation>
    )

}

export default SuccessfullyVerified
